import PropTypes from 'prop-types';
import { Box, Container, Typography } from '@mui/material';

function paragraphsFromBody(body) {
  if (!body) return [];
  if (Array.isArray(body)) return body.filter(Boolean);
  return String(body)
    .split(/\n\n+/)
    .map(part => part.trim())
    .filter(Boolean);
}

export default function StudioIntro({ id, title = '', body = '' }) {
  const paragraphs = paragraphsFromBody(body);

  return (
    <Box
      component="section"
      id={id || undefined}
      sx={{ pt: { xs: 4, md: 6 }, pb: { xs: 1, md: 2 } }}
    >
      <Container maxWidth="md" sx={{ textAlign: 'center' }}>
        {title ? (
          <Typography component="h1" variant="h4" sx={{ fontWeight: 500, mb: 2 }}>
            {title}
          </Typography>
        ) : null}
        {paragraphs.map((paragraph, index) => (
          <Typography
            key={`${index}-${paragraph.slice(0, 24)}`}
            sx={{
              lineHeight: 1.7,
              maxWidth: 640,
              mx: 'auto',
              mb: index < paragraphs.length - 1 ? 2 : 0,
            }}
          >
            {paragraph}
          </Typography>
        ))}
      </Container>
    </Box>
  );
}

StudioIntro.propTypes = {
  id: PropTypes.string,
  title: PropTypes.string,
  body: PropTypes.oneOfType([PropTypes.string, PropTypes.arrayOf(PropTypes.string)]),
};
